import React from 'react'
import { connect } from 'react-redux'

import { selectPartner } from 'containers/App/selectors'

import { PageHeaderSimple } from 'components/lib/PageHeader'

function SettingsHeader({ header, subHeader, partner, extraContent }) {
  return (
    <div className="header">
      <PageHeaderSimple>{partner ? 'Company Settings' : header}</PageHeaderSimple>
      {subHeader && <span className="smaller-text typography-body-1">{` - ${subHeader}`}</span>}
      {extraContent}
    </div>
  )
}

const render = connect((state) => ({
  partner: selectPartner(state),
}))(SettingsHeader)

export default render
